import { Gauge, ShieldAlert } from "lucide-react";

const color = (s) =>
  s >= 70 ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/40"
  : s >= 50 ? "bg-accent/15 text-accent border-accent/40"
  : s >= 35 ? "bg-amber-500/15 text-amber-400 border-amber-500/40"
  : "bg-red-500/15 text-red-400 border-red-500/40";

// Compact investment-score badge for listing cards. Renders nothing when no verified score.
export default function ScoreBadge({ data, className = "" }) {
  if (!data || data.investment_score == null) return null;
  return (
    <span
      data-testid="score-badge"
      title={`Investment: ${data.verdict}${data.band ? ` · ${data.band} band` : ""}`}
      className={`inline-flex items-center gap-1 font-mono-data text-[10px] font-medium uppercase tracking-wider border rounded-full px-2 py-0.5 ${color(data.investment_score)} ${className}`}
    >
      <Gauge className="w-3 h-3" strokeWidth={2} />{data.investment_score}
    </span>
  );
}

// Shown when a listing has no verifiable Market-Intelligence band data (no misleading score).
export function UnverifiedBadge({ className = "" }) {
  return (
    <span
      data-testid="unverified-badge"
      title="Not enough verified comparable data to compute a best-value score"
      className={`inline-flex items-center gap-1 font-mono-data text-[10px] font-medium uppercase tracking-wider border border-border rounded-full px-2 py-0.5 bg-secondary/40 text-muted-foreground ${className}`}
    >
      <ShieldAlert className="w-3 h-3" strokeWidth={2} />Not enough data
    </span>
  );
}

